import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type { Business } from "@adva/types";

interface ListBusinessesResponse {
  businesses: Business[];
}

interface BusinessResponse {
  business: Business;
}

export function useAccountBusinesses() {
  return useQuery({
    queryKey: ["account-businesses"],
    queryFn: () => api.get<ListBusinessesResponse>("/core/businesses"),
  });
}

export function useCreateBusiness() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: {
      name: string;
      vertical?: string;
      description?: string;
      website?: string;
    }) => api.post<BusinessResponse>("/core/businesses", body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["account-businesses"] });
      queryClient.invalidateQueries({ queryKey: ["my-businesses"] });
    },
  });
}

export function useUpdateBusiness() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      ...body
    }: {
      id: string;
      name?: string;
      vertical?: string | null;
      description?: string | null;
      website?: string | null;
      logo_url?: string | null;
      icon_url?: string | null;
      primary_color?: string | null;
      status?: "active" | "inactive";
    }) => api.patch<BusinessResponse>(`/core/businesses/${id}`, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["account-businesses"] });
      queryClient.invalidateQueries({ queryKey: ["my-businesses"] });
    },
  });
}
